"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.transformCustomerToken = void 0;

var _util = require("lodash/util");

var transformCustomerToken = function transformCustomerToken(payload) {
  return payload.customer_token;
};

exports.transformCustomerToken = transformCustomerToken;
var _default = {
  customerToken: (0, _util.stubString)()
};
exports.default = _default;